export default __webpack_public_path__ + "static/media/ilustracao-homem-na-cadeira-de-rodas.e2face5f.svg";